export const VIRTUAL_LOCKER_ADD_ITEM = "VIRTUAL_LOCKER_ADD_ITEM";
export const VIRTUAL_LOCKER_ADD_ITEM_SUCCESS =
  "VIRTUAL_LOCKER_ADD_ITEM_SUCCESS";
export const VIRTUAL_LOCKER_ADD_ITEM_FAIL = "VIRTUAL_LOCKER_ADD_ITEM_FAIL";

export const VIRTUAL_LOCKER_GET_ITEM = "VIRTUAL_LOCKER_GET_ITEM";
export const VIRTUAL_LOCKER_GET_ITEM_SUCCESS =
  "VIRTUAL_LOCKER_GET_ITEM_SUCCESS";
export const VIRTUAL_LOCKER_GET_ITEM_FAIL = "VIRTUAL_LOCKER_GET_ITEM_FAIL";

export const VIRTUAL_LOCKER_ITEM_STATUS_CHANGE = "VIRTUAL_LOCKER_ITEM_STATUS_CHANGE";
export const VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_SUCCESS =
  "VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_SUCCESS";
export const VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_FAIL = "VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_FAIL";

export const VIRTUAL_LOCKER_DELETE_ITEM = "VIRTUAL_LOCKER_DELETE_ITEM";
export const VIRTUAL_LOCKER_DELETE_ITEM_SUCCESS = "VIRTUAL_LOCKER_DELETE_ITEM_SUCCESS";
export const VIRTUAL_LOCKER_DELETE_ITEM_FAIL = "VIRTUAL_LOCKER_DELETE_ITEM_FAIL";

export const VIRTUAL_LOCKER_GET_ITEM_BY_ID = "VIRTUAL_LOCKER_GET_ITEM_BY_ID";
export const VIRTUAL_LOCKER_GET_ITEM_BY_ID_SUCCESS = "VIRTUAL_LOCKER_GET_ITEM_BY_ID_SUCCESS";
export const VIRTUAL_LOCKER_GET_ITEM_BY_ID_FAIL = "VIRTUAL_LOCKER_GET_ITEM_BY_ID_FAIL";

export const VIRTUAL_LOCKER_UPDATE_ITEM = "VIRTUAL_LOCKER_UPDATE_ITEM";
export const VIRTUAL_LOCKER_UPDATE_ITEM_SUCCESS = "VIRTUAL_LOCKER_UPDATE_ITEM_SUCCESS";
export const VIRTUAL_LOCKER_UPDATE_ITEM_FAIL = "VIRTUAL_LOCKER_UPDATE_ITEM_FAIL";
